import { reducedMotion } from './motion.js';
import { isSheet } from './sheet.js';

// Salida de la hoja inferior (movil): inversa de la entrada, mas corta. Escritorio: inclinacion + desvanecido.
const SHEET_EXIT = { duration: 240, drop: 32 };
const DESKTOP_EXIT = { duration: 360, transform: 'perspective(1000px) rotateX(8deg) translateZ(-70px) scale(.97)' };

/** Keep one live dialog/focus scope until tilt and fade finish together. */
export function closeDialogMotion(overlay, onFinished) {
  if (!overlay || reducedMotion() || !overlay.animate) { onFinished(); return () => {}; }
  const box = overlay.querySelector('.modal-box');
  if (!box) { onFinished(); return () => {}; }
  const elements = [overlay, box, ...overlay.querySelectorAll('.modal-header,.modal-title,.modal-body > *,.modal-footer')];
  const snapshots = elements.map(element => ({element, css:element.style.cssText,
    opacity:getComputedStyle(element).opacity, transform:getComputedStyle(element).transform}));
  snapshots.forEach(({element,opacity,transform}) => Object.assign(element.style, {animation:'none',opacity,transform}));
  const previousClosing = overlay.dataset.motionClosing;
  overlay.dataset.motionClosing = 'true';
  const wasInert = box.inert;
  box.inert = true;
  overlay.focus({preventScroll:true});
  box.style.transformOrigin = 'center bottom';
  const sheet = isSheet(overlay);
  const timing = {duration:sheet ? SHEET_EXIT.duration : DESKTOP_EXIT.duration,easing:'cubic-bezier(.2,0,.4,1)',fill:'forwards'};
  // Si se cierra arrastrando, la hoja ya va desplazada: la salida sigue hacia abajo desde ahi (no regresa).
  const dragged = sheet ? new DOMMatrix(snapshots[1].transform).m42 : 0;
  const exitTransform = sheet ? `translateY(${dragged + SHEET_EXIT.drop}px)` : DESKTOP_EXIT.transform;
  const fade = overlay.animate([{opacity:snapshots[0].opacity},{opacity:0}],timing);
  const tilt = box.animate([{opacity:snapshots[1].opacity,transform:snapshots[1].transform},
    {opacity:0,transform:exitTransform}],timing);
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true; media.removeEventListener('change',change);
    onFinished();
  };
  const change = () => { if (media.matches) finish(); };
  fade.onfinish = finish;
  media.addEventListener('change',change);
  return () => {
    finished = true; media.removeEventListener('change',change);
    fade.cancel(); tilt.cancel(); box.inert = wasInert;
    if (previousClosing === undefined) delete overlay.dataset.motionClosing;
    else overlay.dataset.motionClosing = previousClosing;
    snapshots.forEach(({element,css}) => { element.style.cssText = css; });
  };
}
